// extracted by mini-css-extract-plugin
export var dataCell = "_og-2";
export var dataRow = "_og-0";
export var headerRow = "_og-1";